<div class="vi-user-avatar" *ngIf="initials">{{initials}}</div>
